import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { ToastService } from 'shared';
import { ApiInvestigadorService } from 'src/app/core/services/api-investigador.service';
import { removeSpaces } from 'src/app/core/utils/not-empty-validation';
import { removeWhiteSpaces } from 'src/app/core/utils/not-white-space';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-busca-key',
  templateUrl: './modal-busca-key.component.html',
  styleUrls: ['./modal-busca-key.component.scss']
})
export class ModalBuscaKeyComponent implements OnInit {

  form: FormGroup
  environment = environment;
  siteKey = environment.keys.GOOGLE_RECAPTCHA;
  tokenSended = false;
  showError = null;
  loading = false;
  emailPattern = "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$";

  checkCiudadano = true

  tiposDocumentos = [
    {
      name: 'Dni',
      label: 'DNI'
    },
    {
      name: 'CarnetExtranjeria',
      label: 'Carnet de extranjería'
    },
    {
      name: 'Pasaporte',
      label: 'Pasaporte'
    }
  ]

  constructor(
    private toast: ToastService,
    private store: Store,
    public dialogRef: MatDialogRef<ModalBuscaKeyComponent>,
    private formBuilder: FormBuilder,
    private apiInvestigadorService: ApiInvestigadorService,
    @Inject(MAT_DIALOG_DATA) public data: {}
  ) { }

  ngOnInit(): void {
    this.buildForm()
    this.setValidators();
    this.form.get('tipoDocumento').valueChanges.subscribe((value) => {
      if (value === 'Dni' && this.checkCiudadano)
        this.form.get('numeroDocumento').setValidators([Validators.required, Validators.minLength(8), removeSpaces, removeWhiteSpaces, Validators.maxLength(8)]);
      else
        this.form.get('numeroDocumento').setValidators([Validators.required, Validators.minLength(8), removeSpaces, removeWhiteSpaces, Validators.maxLength(18)]);
    });
  }

  buildForm = () => {
    this.form = this.formBuilder.group({
      tipoDocumento: ['Dni'],
      numeroDocumento: ['', [Validators.required, Validators.minLength(8), removeSpaces, removeWhiteSpaces, Validators.maxLength(8)]],
      recaptcha: ['', Validators.required],
      correo: [null, [Validators.required, Validators.pattern(this.emailPattern)]],
    });
  }

  ngOnDestroy() { }

  handleClose = () => {
    this.dialogRef.close();
  }

  handleAceptar = () => {
    this.dialogRef.close();
  }

  handleSuccess = (value) => {
    this.form.get('recaptcha').setValue(value)
  }

  handleEnviar() {
    if (this.loading)
      return false;

    if (this.form.valid) {
      this.loading = true;
      this.apiInvestigadorService.postSolicitarTokenExistente({
        recaptcha: this.form.value.recaptcha,
        correo: this.form.value.correo,
        tipoInvestigador: this.checkCiudadano ? 'Ciudadano' : 'Organizacion',
        tipoDocumento: this.form.value.tipoDocumento,
        numeroDocumento: this.form.value.numeroDocumento
      }).subscribe((value: any) => {
        this.loading = false;
        if (value.success)
          this.tokenSended = true
        else
          this.showError = true
      });
    } else {
      this.toast.error('Se debe registrar todos los campos obligatorios.');
      this.form.markAllAsTouched();
    }
  }

  handleClickCheckCiudadano = () => {
    this.checkCiudadano = !this.checkCiudadano;
    this.setValidators();
  }

  setValidators() {
    if (this.checkCiudadano) {
      this.form.get('tipoDocumento').setValidators([Validators.required]);
      if (this.form.value.tipoDocumento === 'Dni')
        this.form.get('numeroDocumento').setValidators([Validators.required, Validators.minLength(8), removeSpaces, removeWhiteSpaces, Validators.maxLength(8)]);
      else
        this.form.get('numeroDocumento').setValidators([Validators.required, Validators.minLength(8), removeSpaces, removeWhiteSpaces, Validators.maxLength(18)]);
    } else {
      this.form.get('tipoDocumento').setValidators([]);
      this.form.get('numeroDocumento').setValidators([removeSpaces]);
      this.form.get('numeroDocumento').clearValidators();
      this.form.get('numeroDocumento').updateValueAndValidity();
    }
  }
}
